/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { Error400CodeEnum, Error404CodeEnum, Error500CodeEnum } from 'client-code/iptv-login';
import { ErrorTypes } from './ErrorTypes';
import { SignInError } from './SignInError';

export class AuthConfigError extends SignInError {
    TAG: string = 'AuthConfigError';

    constructor(message: string, code: string, description: string) {
        super(code, message);
        this.description = description;
        this.message = message;
        this.setCode(code);
    }

    private setCode(code: string): void {
        switch (code) {
            case Error400CodeEnum.AuthsBadRequest:
                this.code = ErrorTypes.SIGN_IN_AUTH_SERVICE_BAD_REQUEST_C301;
                this.type = Error400CodeEnum.AuthsBadRequest;
                break;
            case Error404CodeEnum.AuthsResourceNotFound:
                this.code = ErrorTypes.SIGN_IN_AUTH_SERVICE_RESOURCE_NOT_FOUND_C302;
                this.type = Error404CodeEnum.AuthsResourceNotFound;
                break;
            case Error500CodeEnum.AuthsInternalServerError:
                this.code = ErrorTypes.SIGN_IN_AUTH_SERVICE_INTERNAL_SERVER_ERROR_C303;
                this.type = Error500CodeEnum.AuthsInternalServerError;
                break;
            default:
                this.code = ErrorTypes.SIGN_IN_AUTH_SERVICE_UNKNOWN_ERROR_C399;
                this.type = 'AUTH_CONFIG_UNKNOWN_ERROR';
        }
    }
}
